import React, { useEffect, useRef, useState } from "react";

interface IGenericStandalonePaymentTypeWrapperProps {
  orderPayload: any;
  togglePlaceOrderButton: (status: boolean) => void;
  buildGenericStandalonePaymentsPayload: any;
  userDetails: any;
  paymentDetails: any;
}

function GenericStandalonePaymentTypeWrapper(props: IGenericStandalonePaymentTypeWrapperProps) {
  const [payloadData, setPayloadData] = useState("");
  const [paymentURL, setPaymentURL] = useState("");

  const genericStandaloneFormRef = useRef<HTMLFormElement>(null);

  const fetchPaymentsPayload = () => {
    props
      .buildGenericStandalonePaymentsPayload(
        props.orderPayload,
        props.userDetails,
        props.paymentDetails
      )
      .then((response: any) => {
        if (!response.error && response?.payload?.data?.payment_payload) {
          setPayloadData(response.payload.data.payment_payload);
          setPaymentURL(response.payload.data.payment_url);
        } else {
          props.togglePlaceOrderButton(true);
        }
      });
  };

  useEffect(() => {
    if (payloadData && paymentURL && genericStandaloneFormRef.current) {
      genericStandaloneFormRef.current?.submit();
    }
  }, [payloadData, paymentURL]);

  return (
    <div>
      <button
        type="submit"
        id="genericStandalonePaymentsCheckoutButton"
        className="hidden"
        onClick={fetchPaymentsPayload}
      ></button>
      {payloadData && paymentURL ? (
        <form
          method="post"
          action={paymentURL}
          name="genericStandaloneTransaction"
          id="genericStandalonePaymentTransaction"
          ref={genericStandaloneFormRef}
        >
          <input name="payment_token" type="hidden" value={payloadData} />
        </form>
      ) : null}
    </div>
  );
}

export default GenericStandalonePaymentTypeWrapper; 